"use strict";

document.addEventListener("DOMContentLoaded", () => {
    document.querySelectorAll(".custom-video .video").forEach((videoContainer) => {
        const playButton = videoContainer.querySelector(".btn-play");
        const videoUrl = videoContainer.getAttribute("data-file");

        if (!playButton || !videoUrl) return;

        const playVideo = (e) => {
            e.preventDefault();

            const video = document.createElement("video");
            video.src = videoUrl;
            video.autoplay = true;
            video.playsinline = true;
            video.controls = true;
            video.setAttribute("tabindex", "-1");

            videoContainer.innerHTML = "";
            videoContainer.appendChild(video);
            video.focus();

            video.play().catch((error) => {
                console.error(error);
            });
        };

        playButton.addEventListener("click", playVideo);

        playButton.addEventListener("keydown", (e) => {
            if (e.key === " " || e.key === "Spacebar") {
                playVideo(e);
            }
        });
    });
});